import { render, staticRenderFns } from "./SoldAppliancesList.vue?vue&type=template&id=0247842b&scoped=true"
import script from "./SoldAppliancesList.vue?vue&type=script&lang=js"
export * from "./SoldAppliancesList.vue?vue&type=script&lang=js"
import style0 from "./SoldAppliancesList.vue?vue&type=style&index=0&id=0247842b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0247842b",
  null
  
)

export default component.exports